const classifyValue = (value) => {
  if (value < 3.5) return 'Soft'
  if (value < 7) return 'Moderate'
  if (value < 10.5) return 'Hard'
  return 'Very Hard'
}

export function getHardnessLevel(hardness = '') {
  const values = String(hardness).match(/\d+(?:\.\d+)?/g)?.map(Number) || []
  if (values.length === 0) return 'Unknown'

  // A published city range can span treatment bands. An average would imply a
  // precision the source does not provide for an individual property.
  const levels = new Set(values.map(classifyValue))
  return levels.size === 1 ? [...levels][0] : 'Variable'
}
